'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
import { FINDER_FILE_CREATE, FINDER_FOLDER_CREATE } from 'DesignData/actions/ActionTypes';
import * as FoldersActions from 'DesignData/actions/finder/Folders';
import * as EcosystemActions from 'DesignData/actions/Ecosystem';
import * as SelectionsActions from 'DesignData/actions/finder/Selections';
import * as finderSelectors from 'DesignData/selectors/finder';
import * as authSelectors from 'DesignData/selectors/auth';
import NewActionsDropdown from 'DesignFinderUI/components/actions/NewActionsDropdown';
import ViewActionsDropdown from 'DesignFinderUI/components/actions/ViewActionsDropdown';
import PrimaryActionsDropdown from 'DesignFinderUI/components/actions/PrimaryActionsDropdown';
import SecondaryActionsDropdown from 'DesignFinderUI/components/actions/SecondaryActionsDropdown';
import ActionModals from 'DesignFinderUI/containers/ActionModals';
/**
 * @class FinderActionsContainer
 */

class FinderActionsContainer extends PureComponent {
  componentDidMount() {
    const {
      hasMarketplacePostingAccess,
      getMarketplaceOfferings
    } = this.props;

    if (hasMarketplacePostingAccess) {
      getMarketplaceOfferings();
    }
  }

  renderDropdown(DropdownComponent, props) {
    return /*#__PURE__*/_jsx(DropdownComponent, Object.assign({
      disabled: this.props.disabled
    }, props));
  }

  renderNewActionsDropdown() {
    const {
      activeFolderId,
      activeFolderPermissions,
      hasMultipleSelections,
      rootFolderId,
      userPermissions,
      activeFileId,
      isThemeRootFolder,
      activeThemeFolderId,
      activeProjectFolderId
    } = this.props;
    const [folderId, folderPermissions] = activeFolderId && activeFolderPermissions ? [activeFolderId, activeFolderPermissions] : [rootFolderId, userPermissions];
    const {
      [FINDER_FILE_CREATE]: canCreateFile,
      [FINDER_FOLDER_CREATE]: canCreateFolder
    } = folderPermissions;
    const baseProps = {
      ['data-test-id']: 'finder__actions-container__new-actions-dropdown-menu',
      key: 'new-actions',
      canCreateFile,
      canCreateFolder,
      folderId
    };

    if (isThemeRootFolder || activeThemeFolderId || activeProjectFolderId || hasMultipleSelections || activeFileId || activeFolderId) {
      return this.renderDropdown(PrimaryActionsDropdown, Object.assign({}, baseProps, {
        fileId: activeFileId
      }));
    }

    return this.renderDropdown(NewActionsDropdown, baseProps);
  }

  renderViewActionsDropdown() {
    const {
      collapseAllFolders,
      deselectAll,
      hasSelections,
      onShowRecentlyDeleted,
      onShowRecentlyEdited,
      openFoldersCount
    } = this.props;
    return this.renderDropdown(ViewActionsDropdown, {
      key: 'view-actions',
      hasSelections,
      onCollapseAllFolders: collapseAllFolders,
      onDeselectAll: deselectAll,
      onShowRecentlyDeleted,
      onShowRecentlyEdited,
      openFoldersCount
    });
  }

  renderSecondaryActionsDropdown() {
    const {
      activeFileId,
      activeFolderId,
      isUserFolderActive
    } = this.props;
    return this.renderDropdown(SecondaryActionsDropdown, {
      key: 'asset-actions-placeholder',
      folderId: activeFolderId,
      fileId: activeFileId,
      isUserFolderActive
    });
  }

  render() {
    const {
      activeFileId,
      activeFolderId
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "finder-actions-container",
      children: [this.renderNewActionsDropdown(), this.renderViewActionsDropdown(), this.renderSecondaryActionsDropdown(), /*#__PURE__*/_jsx(ActionModals, {
        folderId: activeFolderId,
        fileId: activeFileId
      })]
    });
  }

}
/**
 * Statics
 */


FinderActionsContainer.propTypes = {
  activeFileId: FolderPropTypes.folderId,
  activeFolderId: FolderPropTypes.folderId,
  activeFolderPermissions: PropTypes.shape({
    [FINDER_FILE_CREATE]: PropTypes.bool.isRequired,
    [FINDER_FOLDER_CREATE]: PropTypes.bool.isRequired
  }),
  collapseAllFolders: PropTypes.func.isRequired,
  deselectAll: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  getMarketplaceOfferings: PropTypes.func.isRequired,
  hasSelections: PropTypes.bool.isRequired,
  hasMarketplacePostingAccess: PropTypes.bool.isRequired,
  hasMultipleSelections: PropTypes.bool.isRequired,
  isUserFolderActive: PropTypes.bool.isRequired,
  onShowRecentlyDeleted: PropTypes.func.isRequired,
  onShowRecentlyEdited: PropTypes.func.isRequired,
  openFoldersCount: PropTypes.number.isRequired,
  rootFolderId: FolderPropTypes.folderId,
  userPermissions: PropTypes.shape({
    [FINDER_FILE_CREATE]: PropTypes.bool.isRequired,
    [FINDER_FOLDER_CREATE]: PropTypes.bool.isRequired
  }).isRequired,
  isThemeRootFolder: PropTypes.bool.isRequired,
  activeThemeFolderId: FolderPropTypes.folderId,
  activeProjectFolderId: FolderPropTypes.folderId
};
FinderActionsContainer.defaultProps = {
  activeFileId: null,
  activeFolderId: null,
  activeFolderPermissions: {
    [FINDER_FILE_CREATE]: false,
    [FINDER_FOLDER_CREATE]: false
  },
  disabled: false,
  isUserFolderActive: false,
  onShowRecentlyDeleted: emptyFunction,
  onShowRecentlyEdited: emptyFunction,
  openFoldersCount: 0,
  rootFolderId: null,
  userPermissions: {
    [FINDER_FILE_CREATE]: false,
    [FINDER_FOLDER_CREATE]: false
  },
  isThemeRootFolder: false,
  activeThemeFolderId: null,
  activeProjectFolderId: null
};
/**
 * Connect
 */

function makeMapStateToProps() {
  const getActiveFolderPermissions = finderSelectors.makeGetFolderPermissions();
  const getIsUserFolder = finderSelectors.makeGetIsUserFolder();
  return function mapStateToProps(state, props) {
    const activeFolderId = finderSelectors.getActiveFolderId(state);
    let activeFolderPermissions;
    let isUserFolderActive;

    if (activeFolderId) {
      const activeFolderProps = {
        folderId: activeFolderId
      };
      activeFolderPermissions = getActiveFolderPermissions(state, activeFolderProps);
      isUserFolderActive = getIsUserFolder(state, activeFolderProps);
    }

    return {
      activeFileId: finderSelectors.getActiveFileId(state),
      activeFolderId,
      activeFolderPermissions,
      hasSelections: finderSelectors.getHasSelections(state),
      hasMarketplacePostingAccess: authSelectors.getHasMarketplacePostingAccess(state),
      hasMultipleSelections: finderSelectors.getHasMultipleSelections(state),
      isUserFolderActive,
      openFoldersCount: finderSelectors.getOpenFoldersCount(state),
      rootFolderId: finderSelectors.getActiveRootFolderId(state),
      userPermissions: finderSelectors.getUserPermissions(state),
      isThemeRootFolder: finderSelectors.getIsThemeRootFolder(state, props),
      activeThemeFolderId: finderSelectors.getActiveThemeFolderId(state),
      activeProjectFolderId: finderSelectors.getActiveProjectFolderId(state)
    };
  };
}

const mapDispatchToProps = {
  collapseAllFolders: FoldersActions.collapseAllFolders,
  deselectAll: SelectionsActions.deselectAll,
  getMarketplaceOfferings: EcosystemActions.getMarketplaceOfferings
};
/**
 * Export
 */

export default connect(makeMapStateToProps, mapDispatchToProps)(FinderActionsContainer);